var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('stage-indicator',{attrs:{"pipeline-id":_vm.pipelineId,"stage-id":_vm.value.Stage.Id}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }